document.addEventListener('DOMContentLoaded', function(event) {
  attachEventListeners()
});

document.addEventListener('shopify:section:load', (event) => {
    attachEventListeners();
});

function attachEventListeners() {
  window.addEventListener('scroll', debouncedBackToTop);
  
  const playlistTriggers = document.querySelectorAll('.collection-banner__playlist-trigger');

  playlistTriggers.forEach(playlistTrigger => {
    playlistTrigger.addEventListener('click', () => {
      playlistTrigger.classList.toggle('is-active');
    }); 
  });
}

function debounce(func, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

function backToTop() {
  var scrolled = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
  if (scrolled > 500) {
    document.querySelector('.collection__back-to-top').style.opacity = 1;
    document.querySelector('.collection__back-to-top').style.visibility = 'visible';
  } else {
    document.querySelector('.collection__back-to-top').style.opacity = 0;
    document.querySelector('.collection__back-to-top').style.visibility = 'hidden';
  }
}

const debouncedBackToTop = debounce(backToTop, 250); // Adjust the delay as needed


document.addEventListener("DOMContentLoaded", function(event) {

  let urlParams = new URLSearchParams(window.location.search);
  let sizeParam = urlParams.get('Size');
  if (sizeParam) {
    document.querySelectorAll("a.color-swatch").forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
    }); 
  }
});


document.addEventListener('variant:change', function(event) {
  let selectedSize = event.detail.variant.option1.replace(/\s/g, "").toLowerCase().replace("/", '-');
  document.querySelectorAll("a.color-swatch").forEach(link => {
    link.classList.remove("sold-out");
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-' + selectedSize);
    var varInventory = link.getAttribute('data-size-inventory-' + selectedSize);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
    if (varInventory <= 0) {
      link.classList.add("sold-out");
    }
  });  
});


$(document).on('click', '.product-card .variant-picker .color-swatch', function (e) {
  e.preventDefault();
  e.stopPropagation()

  $(this).siblings('.color-swatch').removeClass('is-selected');
  $(this).addClass('is-selected');

  if ($(this).data('swatch-product-image')) {
    let main_image = $(this).parents('.product-card').find('.product-card__image--primary');
    let alt_image = $(this).parents('.product-card').find('.product-card__image--secondary');

    var newImageElement = document.createElement('img');
    newImageElement.className = 'product-card__image product-card__image--primary  aspect-natural';
    newImageElement.setAttribute('width', '1200px');
    newImageElement.setAttribute('height', '1600px');
    newImageElement.setAttribute('src', $(this).data('swatch-product-image'));

    if ($(this).data('swatch-product-alt-image')) {
      var newAltImageElement = document.createElement('img');
      newAltImageElement.className = 'product-card__image product-card__image--secondary  aspect-natural';
      newAltImageElement.setAttribute('src', $(this).data('swatch-product-alt-image'));
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltImageElement);
    } else {
      var newAltImageElement = document.createElement('img');
      newAltImageElement.className = 'product-card__image product-card__image--secondary  aspect-natural';
      newAltImageElement.setAttribute('src', $(this).data('swatch-product-image'));
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltImageElement);
    }

  }
  var productItem = this.closest('.product-card');
  var variantHandle = $(this).data("variant-handle");
  var variantUrl = $(this).data("variant-url");
  var variantTitle = $(this).data("variant-title");
  var variantPrice = $(this).data("variant-price");
  var variantComparePrice = $(this).data("variant-compare-price");
  var variantFullPrice = $(this).data("variant-full-price");
  var variantAvailable = $(this).data("variant-available");
  var swatchProductQuickBuy = $(this).data("swatch-product-quickbuy");

  if (variantFullPrice == "true") {
    productItem.classList.remove("Sale");
    productItem.classList.add("Full");
  } else {
    productItem.classList.remove("Full");
    productItem.classList.add("Sale");
  }
  if (variantAvailable == "true") {
    productItem.classList.remove("Sold-Out");
    productItem.classList.add("Available");
  } else {
    productItem.classList.remove("Available");
    productItem.classList.add("Sold-Out");
  }
  productItem.setAttribute('handle', variantHandle);
  productItem.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
  productItem.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
  productItem.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
  productItem.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
  productItem.querySelectorAll(".product-card__quick-add").forEach(quickAdd => {
    quickAdd.setAttribute("hidden", "")
  });
  productItem.querySelector('.product-card__quick-add[handle="' + variantHandle + '"]').removeAttribute("hidden");
    
});

$(document).on('click', '.product-card__quick-add-mobile', function(e) {
  e.preventDefault();
  $('.product-card').removeClass('is-selected');
  $(this).closest('.product-card').addClass('is-selected');
})
               
$(document).on('click', '.product-card__quick-add-variants li', function(e) {
  e.preventDefault();

  let variant_id = Number($(this).data('variant-id'));
  let product_color = $(this).data('color');

  if(product_color !== '') {
    var data = {
      "id": variant_id,
      "quantity": 1,
      properties: {
        'Color': product_color
      }
    }
  } else {
    var data = {
      "id": variant_id,
      "quantity": 1
    }
  }
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.querySelector('.header__cart-link a').click();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,  //this code is for prestige theme, is to refresh the cart
        detail: {
          quantity: 1
        }
      }));
    }   
  }); 
  
})

$(document).on('click', '.product-card-horizontal__quick-add-variants li', function(e) {
  e.preventDefault();

  let variant_id = Number($(this).data('variant-id'));
  let product_color = $(this).data('color');

  if(product_color !== '') {
    var data = {
      "id": variant_id,
      "quantity": 1,
      properties: {
        'Color': product_color
      }
    }
  } else {
    var data = {
      "id": variant_id,
      "quantity": 1
    }
  }
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,  //this code is for prestige theme, is to refresh the cart
        detail: {
          quantity: 1
        }
      }));
    }   
  }); 
  
})

$(document).on('click', '.swatch-products-more', function () {
  $(this).remove();
});

const preloadSwatchImage = (element) => {
  const imageURL = element.dataset.swatchProductImage;
  if (imageURL) {
    const img = new Image();
    img.src = imageURL;
    img.onload = () => {
      element.addEventListener('mouseover', () => {
        element.src = imageURL;
      });
    };
  }
};

const elements = document.querySelectorAll('[data-swatch-product-image]');
elements.forEach(preloadSwatchImage);